import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Reveal } from "@/components/site/Motion";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, [slug]);

  return (
    <div className="bg-stone-50 min-h-screen">
      <Navbar />
      <main className="px-6 md:px-12 lg:px-24 pt-40 md:pt-52 pb-24">
        <button onClick={() => navigate("/blog")} data-testid="back-to-blog" className="inline-flex items-center gap-2 font-sans text-sm text-subtle hover:text-ink transition-colors duration-300 mb-10">
          <ArrowLeft size={16} /> Volver al blog
        </button>

        {notFound && <p className="font-serif text-3xl text-ink">Artículo no encontrado. <Link to="/blog" className="underline">Ver blog</Link></p>}

        {post && (
          <article className="max-w-3xl">
            <Reveal>
              <h1 data-testid="post-title" className="font-serif text-4xl md:text-6xl tracking-tight text-ink leading-[1.05]">{post.title}</h1>
              <p className="font-sans text-lg text-subtle mt-6">{post.excerpt}</p>
            </Reveal>
            {post.cover_image && (
              <Reveal delay={0.1}>
                <div className="overflow-hidden aspect-[16/9] bg-stone-100 rounded-sm my-12">
                  <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
                </div>
              </Reveal>
            )}
            <Reveal delay={0.15}>
              <div className="font-sans text-lg text-subtle leading-relaxed space-y-6">
                {post.content.split("\n\n").map((para, i) => <p key={i}>{para}</p>)}
              </div>
            </Reveal>
          </article>
        )}
      </main>
      <Footer content={content} />
    </div>
  );
}
